import script from "./FixedButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixedButtons.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=fd5324c6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd5324c6"]])

export default __exports__